/**
 * tags input placeholder config (csak így megy hogy ne legyen...)
 * Created by csaba.adam on 2016. 08. 24..
 */
export default function (app) {
	app.config(['tagsInputConfigProvider', function (tagsInputConfigProvider) {
		tagsInputConfigProvider.setDefaults('tagsInput', {
			placeholder: ''
		});
		tagsInputConfigProvider.setActiveInterpolation('tagsInput', { placeholder: true });
	}]);
};
